import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { ScrollArea } from '@/components/ui/scroll-area';

const ApplianceDeleteDialog = ({ isOpen, onClose, onDelete, onDeleteAll, appliances, categoryName }) => {
    const [selectedApplianceId, setSelectedApplianceId] = useState('');

    const handleDelete = () => {
        if (selectedApplianceId) {
            onDelete(selectedApplianceId);
            setSelectedApplianceId('');
        }
    };

    const handleDeleteAll = () => {
        onDeleteAll();
        setSelectedApplianceId('');
    };

    return (
        <Dialog
            open={isOpen}
            onOpenChange={() => {
                onClose();
                setSelectedApplianceId('');
            }}
        >
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Select {categoryName} to Remove</DialogTitle>
                    <DialogDescription>Select individual appliance or remove all {categoryName}s</DialogDescription>
                </DialogHeader>

                <ScrollArea className="max-h-[300px] pr-4">
                    <RadioGroup
                        value={selectedApplianceId}
                        onValueChange={setSelectedApplianceId}
                        className="space-y-3"
                    >
                        {appliances.map((appliance, index) => (
                            <div key={appliance.id} className="flex items-center space-x-2 border p-3 rounded-lg">
                                <RadioGroupItem value={appliance.id} id={appliance.id} />
                                <Label htmlFor={appliance.id} className="flex-1 cursor-pointer">
                                    <div className="font-medium">
                                        {categoryName} {index + 1}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                        {appliance.dimensions
                                            ? `${appliance.dimensions.width}" × ${appliance.dimensions.depth}" × ${appliance.dimensions.height}"`
                                            : 'No dimensions set'}
                                    </div>
                                    {appliance.additionalInfo && (
                                        <div className="text-sm text-gray-500">{appliance.additionalInfo}</div>
                                    )}
                                </Label>
                            </div>
                        ))}
                    </RadioGroup>
                </ScrollArea>

                <div className="flex flex-col gap-2">
                    <Button variant="destructive" onClick={handleDeleteAll} className="w-full">
                        <Trash2 className="w-4 h-4 mr-2" />
                        Remove All {categoryName}s
                    </Button>

                    <div className="flex gap-2">
                        <Button variant="secondary" onClick={onClose} className="flex-1">
                            Cancel
                        </Button>
                        <Button
                            variant="destructive"
                            onClick={handleDelete}
                            disabled={!selectedApplianceId}
                            className="flex-1"
                        >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Remove Selected
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ApplianceDeleteDialog;
